<template>
  <div id="map-chart">
    <div class="chart-title">辖区地图</div>
      <img class="img" src="https://panda-file.gotoschool.cc/img/2024/1/c2cec3fdfc039245d68842eb99c6b3c27d1ed31b8f8f.png" alt=""
           style="width: 100%;"/>
  </div>
</template>

<script>
import { getRandomNumber } from '@/utils/common'

export default {
  name: 'AreaMap',
  data () {
    return {
      config: {
        data: [getRandomNumber(96.1, 98.8)],
        shape: 'round',
        waveHeight: 25,
        waveNum: 2
      }
    }
  }
}
</script>

<style lang="less">
#map-chart {
  width: 20%;
  box-sizing: border-box;
  margin-left: 20px;
  background-color: rgba(6, 30, 93, 0.5);
  border-top: 2px solid rgba(1, 153, 209, .5);
  display: flex;
  flex-direction: column;

  .chart-title {
    font-weight: bold;
    height: 50px;
    display: flex;
    align-items: center;
    font-size: 20px;
    justify-content: center;
  }
  .img {
    width: 100%;

  }

}
</style>
